// extracted by mini-css-extract-plugin
export var active = "_eb-7";
export var blink = "_eb-8";
export var dropDownSelector = "_eb-4";
export var dropDownWrapper = "_eb-3";
export var fakeCursor = "_eb-6";
export var fontSizeButton = "_eb-9";
export var formQuillEditor = "_eb-0";
export var pressed = "_eb-a";
export var qlBlank = "_eb-1";
export var textFormattingToolbar = "_eb-2";
export var textToolbarOption = "_eb-5";